var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2786 39C29.6924 39 38.1344 30.2696 38.1344 19.5C38.1344 8.73045 29.6924 0 19.2786 0C8.86487 0 0.422852 8.73045 0.422852 19.5C0.422852 30.2696 8.86487 39 19.2786 39Z",
    fill: "#D0021B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.321 13.3377C27.1526 13.572 27.8075 14.2622 28.0298 15.1386C28.4336 16.7271 28.4336 20.0414 28.4336 20.0414C28.4336 20.0414 28.4336 23.3556 28.0298 24.9441C27.8075 25.8205 27.1526 26.482 26.321 26.7162C24.8137 27.1418 18.7698 27.1418 18.7698 27.1418C18.7698 27.1418 12.7259 27.1418 11.2186 26.7162C10.387 26.482 9.73211 25.8205 9.50983 24.9441C9.10596 23.3556 9.10596 20.0414 9.10596 20.0414C9.10596 20.0414 9.10596 16.7271 9.50983 15.1386C9.73211 14.2622 10.387 13.572 11.2186 13.3377C12.7259 12.9121 18.7698 12.9121 18.7698 12.9121C18.7698 12.9121 24.8137 12.9121 26.321 13.3377ZM16.7926 17.032V23.0502L21.8441 20.0412L16.7926 17.032Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 20,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.321 13.3377C27.1526 13.572 27.8075 14.2622 28.0298 15.1386C28.4336 16.7271 28.4336 20.0414 28.4336 20.0414C28.4336 20.0414 28.4336 23.3556 28.0298 24.9441C27.8075 25.8205 27.1526 26.482 26.321 26.7162C24.8137 27.1418 18.7698 27.1418 18.7698 27.1418C18.7698 27.1418 12.7259 27.1418 11.2186 26.7162C10.387 26.482 9.73211 25.8205 9.50983 24.9441C9.10596 23.3556 9.10596 20.0414 9.10596 20.0414C9.10596 20.0414 9.10596 16.7271 9.50983 15.1386C9.73211 14.2622 10.387 13.572 11.2186 13.3377C12.7259 12.9121 18.7698 12.9121 18.7698 12.9121C18.7698 12.9121 24.8137 12.9121 26.321 13.3377ZM16.7926 17.032V23.0502L21.8441 20.0412L16.7926 17.032Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_102)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.48668c91491dad53b8dace49b1b89604.svg";
export { ForwardRef as ReactComponent };